/*/=======================================================================================\*\
|| IMPORTS DE COMPONENTES PROPIOS DEL PROYECTO                                             ||
\*\=======================================================================================/*/
import styles from './Inicio.module.css';
import { ROUTES } from '../../const/routes';
import BannerLogo from '../../components/BannerLogo/BannerLogo';
import ImagenTragamonedasInicio from '../../components/ImagenTragamonedasInicio/ImagenTragamonedasInicio';
import BotonGrandeDinamico from '../../components/Botones/BotonGrandeDinamico/BotonGrandeDinamico';
import Footer from '../../components/Footer/Footer';
import { useTranslation } from 'react-i18next';

/*/=======================================================================================\*\
|| PÁGINA INICIO                                                                           ||
\*\=======================================================================================/*/
const Inicio = () => {
  const { t } = useTranslation();
  return (
    <div className={'flex flex-col min-h-screen ' + styles.inicioContainer}>
      <div className="flex flex-col flex-grow items-center justify-between text-center px-4">
        <BannerLogo />
        <div className="flex flex-col lg:flex-row justify-center items-center lg:items-end w-full max-w-5xl gap-4 lg:gap-8 mb-4">
          <div className="w-full lg:w-auto flex justify-center order-1 lg:order-1">
            <ImagenTragamonedasInicio />
          </div>
          <div
            className="p-5 lg:p-6 w-full max-w-md md:max-w-lg lg:max-w-xl space-y-3 flex flex-col bg-bgContenedorOscuro
          rounded-lg border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-[0_0_30px_rgba(100,116,139,0.9)]
          transition-all duration-300 ease-in-out hover:shadow-[0_0_40px_rgba(100,116,139,1)] order-2 lg:order-2"
          >
            <h2 className="text-xl text-yellow-500 font-bold mb-2">
              {t('home.title')}
            </h2>
            <p className="text-sm text-gray-300 mb-4">
              {t('home.subtitle1')} <br />
              {t('home.subtitle2')}
            </p>
            <BotonGrandeDinamico
              texto={t('home.loginButton')}
              bgColor="blue"
              direccion={ROUTES.login}
            />
            <BotonGrandeDinamico
              texto={t('home.registerButton')}
              bgColor="pink"
              direccion={ROUTES.register}
            />
            <BotonGrandeDinamico
              texto={t('home.aboutButton')}
              bgColor="orange"
              direccion={ROUTES.queCasinoPrint}
            />
          </div>
        </div>
      </div>

      <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default Inicio;
